<template>
  <div :class="bem()">
    <template v-if="isLoading">
      <nx-inline-loading class="loadingImg" type="swivel-image"></nx-inline-loading>
      <!-- <v-loading :size="size" color="#6683F7" style="text-align: center" /> -->
      <span class="text" v-if="loadingText">{{ loadingText }}</span>
    </template>
    <template v-else>
      <div class="text" v-if="noMoreText">{{ noMoreText }}</div>
    </template>
  </div>
</template>

<script>
import { create } from '../utils'
import { InlineLoading } from '@vivo/vos-ui'
export default create({
  name: 'loading-more',
  components: {
    [InlineLoading.name]: InlineLoading
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    loadingText: {
      type: String,
      default: '正在加载'
    },
    noMoreText: {
      type: String,
      default: '已经到底了~'
    }
  },
  data() {
    return {
      size: 12
    }
  }
})
</script>

<style lang="scss">
.v-loading-more {
  height: 120px;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  .loadingImg {
    margin-right: 15px;
  }
  .text {
    text-align: center;
    color: #999;
  }
}
</style>
